import React from "react";
import { Nav, Loader, Button } from "ui-kit-ck-consultant";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";

import Planning from "../../components/home/Planning";
import Filters from "../../components/home/Filters";
import Folders from "../../components/home/Folders";
import ModalInsertFolder from "../../components/home/ModalInsertFolder";

import axiosConfig from "../../utils/axiosConfig";

export default class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoad: true,
      tmpFolders: [],
      folders: [],
      isModalInsertFolder: false,
      reference: "",
      dateStart: "",
      dateEnd: "",
      licensePlate: "",
      insuredName: "",
      company: "DEFAULT",
      region: "DEFAULT",
      agency: "DEFAULT",
      expert: "DEFAULT",
    };
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState(
      {
        [name]: value,
      },
      this.filterFolders
    );
  };

  componentDidMount() {
    this.getFolders();
  }

  filterFolders = () => {
    let folders = this.state.tmpFolders.filter(
      (element) =>
        (!this.state.reference ||
          element.reference.includes(this.state.reference)) &&
        (!this.state.dateStart ||
          moment(element.date.split(" ")[0], "DD/MM/YYYY").isSameOrAfter(
            moment(this.state.dateStart, "YYYY-MM-DD")
          )) &&
        (!this.state.dateEnd ||
          moment(element.date.split(" ")[0], "DD/MM/YYYY").isSameOrBefore(
            moment(this.state.dateEnd, "YYYY-MM-DD")
          )) &&
        (!this.state.licensePlate ||
          element.licensePlate.includes(this.state.licensePlate)) &&
        (!this.state.insuredName ||
          element.insuredName.includes(this.state.insuredName)) &&
        (this.state.company === "DEFAULT" ||
          element.company.toString() === this.state.company) &&
        (this.state.region === "DEFAULT" ||
          (element.regionName || "").toString() === this.state.region) &&
        (this.state.agency === "DEFAULT" ||
          (element.agencyName || "").toString() === this.state.agency) &&
        (this.state.expert === "DEFAULT" ||
          (element.expertName || "").toString() === this.state.expert)
    );

    this.setState({ folders });
  };

  // start getFolders

  getFolders = () => {
    axiosConfig("folder/get-folders")
      .then((res) => {
        if (res.data.success) {
          this.setState(
            { isLoad: false, tmpFolders: res.data.folders },
            this.filterFolders
          );
        } else if (res.data.err === "no result") {
          this.setState({ isLoad: false, tmpFolders: res.data.folders });
        } else {
          this.getFolderError();
        }
      })
      .catch(this.getFolderError);
  };

  getFolderError = () => {
    this.setState({ isLoad: false }, () =>
      alert("Une erreur est survenue, veuillez actualiser la page")
    );
  };

  // end getFolders

  // start deleteFolder

  deleteFolder = (idx) => {
    this.setState({ isLoad: true }, () => {
      axiosConfig("folder/delete-folder", {
        data: {
          id: this.state.folders[idx].id,
        },
      })
        .then((res) => {
          if (res.data.success) {
            let tmpFolders = this.state.folders;
            tmpFolders.splice(idx, 1);
            this.setState({ isLoad: false, tmpFolders }, this.filterFolders);
          } else {
            this.deleteFolderError();
          }
        })
        .catch(this.deleteFolderError);
    });
  };

  deleteFolderError = () => {
    this.setState({ isLoad: false }, () => alert("Une erreur est survenue."));
  };

  // end deleteFolder

  // start closeFolder

  closeFolder = (idx) => {
    this.setState({ isLoad: true }, () => {
      axiosConfig("folder/update-status-folder", {
        data: {
          id: this.state.folders[idx].id,
          status: 4,
        },
      })
        .then((res) => {
          if (res.data.success) {
            let tmpFolders = this.state.folders;
            tmpFolders[idx].status = 4;
            this.setState({ isLoad: false, tmpFolders }, this.filterFolders);
          } else {
            this.closeFolderError();
          }
        })
        .catch(this.closeFolderError);
    });
  };

  closeFolderError = () => {
    this.setState({ isLoad: false }, () => alert("Une erreur est survenue."));
  };

  // end closeFolder

  render() {
    return (
      <>
        <Nav title="Accueil" className="mb-10 mb-20-xl">
          <Button
            className="ml-5"
            text="Nouveau dossier"
            onClick={() => this.setState({ isModalInsertFolder: true })}
          >
            <FontAwesomeIcon icon={faPlus} />
          </Button>
        </Nav>
        <Planning />
        <Filters
          folders={this.state.folders}
          reference={this.state.reference}
          dateStart={this.state.dateStart}
          dateEnd={this.state.dateEnd}
          licensePlate={this.state.licensePlate}
          insuredName={this.state.insuredName}
          company={this.state.company}
          region={this.state.region}
          agency={this.state.agency}
          expert={this.state.expert}
          handleInputChange={this.handleInputChange}
        />
        <Folders folders={this.state.folders} getFolders={this.getFolders} />

        <ModalInsertFolder
          onClose={(isReload) => {
            if (isReload) {
              this.getFolders();
            }
            this.setState({ isModalInsertFolder: false });
          }}
          show={this.state.isModalInsertFolder}
        />
        <Loader show={this.state.isLoad} />
      </>
    );
  }
}
